import './file-list.scss';
import React from 'react';
import { T } from 'shared/helper/translate';
import File from './File';
var noop = function noop() {};
var FileList = function FileList(_ref) {
  var _ref$fileRenderer = _ref.fileRenderer,
    FileRenderer = _ref$fileRenderer === void 0 ? File : _ref$fileRenderer,
    files = _ref.files,
    _ref$onFileRemoved = _ref.onFileRemoved,
    onFileRemoved = _ref$onFileRemoved === void 0 ? noop : _ref$onFileRemoved,
    progress = _ref.progress,
    disabled = _ref.disabled,
    _removeFile = _ref.removeFile;
  var emptyFiles = files.length === 0;
  return /*#__PURE__*/React.createElement("div", {
    className: "file-list ".concat(emptyFiles ? 'empty-set' : '')
  }, emptyFiles ? /*#__PURE__*/React.createElement("i", null, /*#__PURE__*/React.createElement(T, {
    source: "After you select your files, they will appear here."
  })) : files.map(function (file) {
    return /*#__PURE__*/React.createElement(FileRenderer, {
      disabled: disabled,
      file: file,
      key: file.name + file.uploadedAt + file.identity,
      progress: progress,
      removeFile: function removeFile() {
        onFileRemoved(file);
        return _removeFile(file);
      }
    });
  }));
};
export default FileList;